/* eslint-disable @typescript-eslint/no-var-requires */
import React, {
  FunctionComponent,
  MutableRefObject,
  useEffect,
  useRef,
  useState,
} from 'react';

import './animation022.less';
import { usePlayFlag } from './../../components/topicScroll';
import ImgPoint from '../../../../../assets/animation_point.gif';
import { Button, Modal } from 'antd';

interface IAnimation022Item {
  color: string;
  number: string;
  text: string;
  title: string;
  viewMore?: boolean;
  tip?: string;
  linkDetail?: IHyperLinkItem;
}

interface IHyperLinkItem {
  label: string;
  linkText: string;
  link?: string;
}

interface IAnimation022Props {
  items: IAnimation022Item[];
  pic: string;
  inTitle: string;
  content: string;
  onCompleted: () => void;
}

const Animation022: FunctionComponent<IAnimation022Props> = ({
  items,
  pic,
  content,
  inTitle,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation022 onCompleted');
      onCompleted && onCompleted();
    }
  };

  useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };
  const [isModalOpen, setModalOpen] = useState(false);
  const [show, setShow] = useState(true);
  return (
    <div ref={crrRef} className="animation022 component">
      <div className="animation022-content">
        {items.map((itm: IAnimation022Item, idx: number) => (
          <div
            key={idx}
            className={`animation022-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            onClick={() => clickToPlay()}
          >
            <>
              <img
                className="click-point"
                onClick={() => clickToPlay()}
                style={{
                  display: play <= 1 ? 'block' : 'none',
                }}
                src={ImgPoint}
                alt=""
              />
              <div className="animation022-number" style={{ color: itm.color }}>
                {itm.number}
              </div>
              <div className="animation022-item-content">
                <div className="animation022-item-title">{itm.title}</div>
                <div className="animation022-item-text">
                  {itm.text}
                  {itm.viewMore ? (
                    <span className="view-more">
                      <Button
                        className="view-more-btn"
                        onClick={() => {
                          setModalOpen(true);
                          setShow(false);
                        }}
                        type="link"
                      >
                        {itm.tip}
                      </Button>
                      <img
                        className="click-point1"
                        hidden={!show}
                        src={ImgPoint}
                        alt=""
                      />
                    </span>
                  ) : null}
                  {itm.linkDetail && (
                    <div style={{ color: itm.color }} className="linkDetail">
                      （{itm.linkDetail.label}
                      <a
                        href={itm.linkDetail.link}
                        key={`link${idx}`}
                        style={{ color: itm.color }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {itm.linkDetail.linkText}
                      </a>
                      ）
                    </div>
                  )}
                </div>
              </div>
            </>
          </div>
        ))}
      </div>
      <Modal
        width="60%"
        className="animation022-modal-fsi"
        title={inTitle}
        footer={null}
        open={isModalOpen}
        onCancel={() => setModalOpen(false)}
      >
        <img src={require(`../../../../../assets/${pic}`).default} alt="" />
        <div className="animation022-modal-content">{content}</div>
      </Modal>
    </div>
  );
};

export default Animation022;
